module.exports = __webpack_public_path__ + "violin.jpg?7743e399ffcc3732be2c26145648f937";